module.exports = __webpack_public_path__ + "static/media/chevron.9f5dcf84.svg";